<template>
  <div v-if="modelValue" class="common-dialog cover-layer">
    <component
      :is="type"
      v-bind="$props"
      @confirm="handleAction('confirm')"
      @model-input="handleAction('modelInput', false)"
      class="common-dialog__content"
    >
      <slot></slot>
    </component>
  </div>
</template>

<script>
import Prompt from './components/prompt'
import Confirm from './components/confirm'
import Verification from './components/verification'
export default {
  name: 'common-dialog',
  components: {
    Prompt,
    Confirm,
    Verification
  },

  model: {
    prop: 'modelValue',
    event: 'modelInput'
  },

  props: {
    modelValue: Boolean,
    type: {
      type: String,
      default: 'confirm',
      validator(value) {
        return ['prompt', 'confirm', 'verification'].indexOf(value) !== -1
      },
      comment: '弹窗的显示类型值 默认: confirm'
    },
    header: {
      type: String,
      default: '鉴权',
      comment: '头部显示文字'
    },
    tips: {
      type: Boolean,
      default: false,
      comment: '是否显示危险操作提示'
    },
    title: {
      type: String,
      defaul: '',
      comment: '蓝色文字的标题比如: 商户查询类业务更新操作/批量映射渠道'
    },
    operation: {
      type: Boolean,
      default: false,
      comment: `当类型为verification事是否展示操作人的授权输入框 如果不设置那么只有一个授权人的授权输入框`
    },
    cancelText: {
      type: String,
      default: '',
      comment: `取消按钮弹窗 type 为 confirm 类型才有效 当设置了按钮文本时则会显示取消按钮`
    },
    confirmText: {
      type: String,
      default: '确认提交',
      comment: '确认按钮文本'
    },
    hiddenButton: {
      type: Boolean,
      default: false,
      comment: '是否隐藏下面的按钮'
    },
    btnColor: {
      type: String,
      default: '',
      comment: '设置按钮颜色'
    }
  },

  data() {
    return {}
  },

  watch: {
    modelValue: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue) {
          document.documentElement.classList.add('lock')
        } else {
          document.documentElement.classList.remove('lock')
        }
      }
    }
  },

  methods: {
    handleAction(action, value) {
      this.$emit(action, value)
      return Promise.resolve(value)
    }
  }
}
</script>

<style lang="scss" scoped>
.common-dialog {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
  background: rgba($color: #000, $alpha: 0.5);
  z-index: 100;

  &__content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 10px;
    background: #fff;
    overflow: hidden;
  }
}
</style>

